import { useCallback, useEffect, useState } from "react"
import axios from 'axios'
import {useDispatch} from "react-redux";
import {clearAllData} from "../redux/actions";
import {SET_THEME, TOGGLE_TRUE_LOGGED_CLIENT} from "../redux/types";

const storageName = 'userData'
const themeStorage = 'theme'

export const useAuth = () => {

    const [token, setToken] = useState(null)
    const [userId, setUserId] = useState(null)
    const dispatch = useDispatch()

    const login = useCallback((jwtToken, id) => {
        setToken(jwtToken)
        setUserId(id)

        localStorage.setItem(storageName, JSON.stringify({
            userId: id, token: jwtToken
        }))
    }, [])

    const logout = useCallback(async () => {
        setToken(null)
        setUserId(null)

        dispatch(clearAllData())

        // const logOutToken = await JSON.parse(localStorage.getItem(storageName))
        //
        // await axios.get(`http://185.217.131.192/api/logout/`, {
        //     headers: {
        //         "Content-Type": "application/json",
        //         Authorization: `Token ${logOutToken.token}`
        //     }
        // }).then(() => dispatch(clearAllData()))

        localStorage.removeItem(storageName)
        localStorage.removeItem(`newCreatedUserData`)

    }, [])

    useEffect(() => {
        const data = JSON.parse(localStorage.getItem(storageName))
        const clientLogIn = JSON.parse(localStorage.getItem(`newCreatedUserData`))

        const theme = JSON.parse(localStorage.getItem(themeStorage))

        if (!theme) {
            localStorage.setItem(themeStorage, JSON.stringify({
                theme: 'light'
            }))
        }

        if (theme?.theme) {
            dispatch({type: SET_THEME, payload: theme.theme})
        }

        if (data && data.token) {
            login(data.token, data.userId)
        }
        if (clientLogIn && clientLogIn.newUserName) {
            dispatch({type: TOGGLE_TRUE_LOGGED_CLIENT})
        }
    }, [login])

    return {login, logout, token, userId}
}